export interface Stage {
  id: number;
  stage_name: string;
  description: string | null;
  is_active: boolean;
    sequence: number;

}

export const DEFAULT_STAGE = {
  commentRequired: false,
  date: {
    required: true,
    noPast: true,
    noFuture: false,
    label: "Select Date",
  },
  assignedTo: true,
  status: true,
};
export const STAGE_CONFIG: Record<string, any> = {
  new: {
  commentRequired: false,
  date: null,
  assignedTo: false,   // 🔥 change
  status: false,       // 🔥 change
},
  followup: {
    commentRequired: false,
    date: {
      required: true,
      noPast: true,
      noFuture: false,
      label: "Select Date",
    },
    assignedTo: true,
    status: true,
  },

  showroomvisit: {
    commentRequired: false,
    date: {
      required: true,
      noPast: true,
    },
    assignedTo: true,
    status: true,
  },

  won: {
    commentRequired: true,
    date: {
      required: true,
      noPast: true,
    },
    assignedTo: true,
    status: true,
  },

  lost: {
    commentRequired: true,
    date: {
      required: true,
      noPast: true,
    },
    assignedTo: true,
    status: true,
  },

  hold: {
    commentRequired: true,
    date: {
      required: true,
      noPast: true,
    },
    assignedTo: true,
    status: true,
  },

  rfq: {
    commentRequired: false,
    date: {
      required: true,      // ✅ WAS false
      noFuture: true,
    },
    assignedTo: true,
    status: true,
  },

  rfqvalue: {
    commentRequired: false,
    date: {
      required: true,      // ✅ WAS false
      noFuture: true,
    },
    assignedTo: true,
    status: true,
    rfqValue: true,
  },

  quotation: {
    commentRequired: true,
    date: {
      required: true,      // ✅ WAS false
      noFuture: true,
    },
    assignedTo: true,
    status: true,
    quote: {
      required: true,
    },
    hatchwayValue: {
      required: true,
    },
  },
};
